// SPDX-License-Identifier: Apache-2.0
import ServerOgc from '../serverogc';
import LayerWms, { LayerWmsOptions } from './layerwms';

/*
 * This class is a used in the state of the application, which will be accessed behind a javascript proxy.
 * This means that each modification made to its properties must come from outside,
 * because they have to be made through the proxy, so that the modification can be listen.
 * Therefore, this class must not contain any method which is updating a value directly
 * For example, any method doing <this.xxx = value> is forbidden here, because the modification be known from the proxy
 */
export default class LayerWmsExternal extends LayerWms {
  private static nextAvailableLayerId = 10000000;

  private selected: boolean = false;

  public get isSelected() {
    return this.selected;
  }

  public set isSelected(value) {
    this.selected = value;
    this.isDefaultChecked = value;
  }

  public constructor(title: string, name: string, ogcServer: ServerOgc) {
    const id = LayerWmsExternal.nextAvailableLayerId++;
    const options: LayerWmsOptions = {
      layers: name,
      queryable: true,
      legend: true,
      isLegendExpanded: false
    };

    super(id, title, 0, ogcServer, options);
  }

  public override clone(): LayerWmsExternal {
    const clonedLayer = new LayerWmsExternal(this.name, this.layers!, this.ogcServer);
    clonedLayer.isSelected = this.isSelected;
    return clonedLayer;
  }
}
